import { INPAGE_MODULE_BLOCKLIST } from 'ContentEditorUI/lib/widgetEdit/constants';
import { createSelector } from 'reselect';
import { getAuth } from 'ContentEditorUI/redux/selectors/authSelectors';
// @ts-expect-error not typed yet
import { processModuleForIPEUI } from 'ContentEditorUI/lib/InpageUtils';
import { getModules, getUneditableModules, makeGetAnyModuleById, getModuleLists } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { convertRgbaStringToRgbaObject, convertRgbaToHexAndAlphaInt } from 'ContentUtils/helpers/ColorsHelpers';
// @ts-expect-error not typed yet
import { buildTreeNodeDomSelector } from 'layout-dnd-utils/layoutTreeStyles/helpers';
import { getModuleSchemas, getBuiltInTypesByModuleId, getCustomModuleIds, buildFakeModuleSchemasSlice } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import { buildFakeModuleSlice, buildFakeModuleSliceImmer } from './moduleSelectorHelpers';
import { InpageModes } from 'ContentEditorUI/lib/app/constants';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { getIsBlogPost } from './contentReadOnlyDataSelectors';
import { getIsUngatedForImmerModuleReducer } from './authSelectors';
import { getGridNodeElementSelector } from 'layout-dnd-utils/grids/render/domSelectors';
import { stringSizeToChirpSize } from 'layout-dnd-utils/grids/render/css/gridLayoutStyleUtils';
const getInpageData = basicSelector(state => state.inpageData);
const createInpageSelector = field => {
  return createSelector([getInpageData], inpageData => inpageData ? inpageData[field] : null);
};
export const getCurrentInpageMode = createInpageSelector('inpageMode');
export const getHighlightedWidgetId = createInpageSelector('highlightedWidgetId');
export const getHighlightedWidgetContainerId = createInpageSelector('highlightedWidgetContainerId');
export const getScrollToModuleId = createInpageSelector('scrollToModuleId');
export const getScrollToNodePositionId = createInpageSelector('scrollToNodePositionInfo');
export const getIsDraggingModule = createInpageSelector('isDraggingModule');
export const getIsInLegacyLayoutMode = createSelector(getCurrentInpageMode, currentInpageMode => currentInpageMode === InpageModes.LAYOUT);
export const getPreviewViewportDimensions = createInpageSelector('previewViewportDimensions');
const getPreviewWrapperScroll = createInpageSelector('previewWrapperScroll');
export const getPreviewScrollPosition = createInpageSelector('previewScrollPosition');
export const getHasInpagePreviewUnexpectedlyUnloaded = createInpageSelector('inpagePreviewUnexpectedlyUnloaded');
export const getFailedInpageAssets = createInpageSelector('failedInpageAssets');
export const getDomReadyBlockingResource = createInpageSelector('domReadyBlockingResource');
export const getInpageJsLoadedMultipleTimes = createInpageSelector('inpageJsLoadedMultipleTimes');
export const getPreviewViewportWidth = createSelector(getPreviewViewportDimensions, previewViewportDimensions => {
  var _previewViewportDimen;
  return (_previewViewportDimen = previewViewportDimensions === null || previewViewportDimensions === void 0 ? void 0 : previewViewportDimensions.width) !== null && _previewViewportDimen !== void 0 ? _previewViewportDimen : 0;
});
export const getPreviewIframeLeftOffset = createSelector(getPreviewViewportDimensions, previewViewportDimensions => {
  var _previewViewportDimen2;
  return (_previewViewportDimen2 = previewViewportDimensions === null || previewViewportDimensions === void 0 ? void 0 : previewViewportDimensions.iframeLeftOffset) !== null && _previewViewportDimen2 !== void 0 ? _previewViewportDimen2 : 0;
});
export const getPreviewViewportHeight = createSelector(getPreviewViewportDimensions, previewViewportDimensions => {
  var _previewViewportDimen3;
  return (_previewViewportDimen3 = previewViewportDimensions === null || previewViewportDimensions === void 0 ? void 0 : previewViewportDimensions.height) !== null && _previewViewportDimen3 !== void 0 ? _previewViewportDimen3 : 0;
});
export const getPreviewWrapperScrollLeft = createSelector(getPreviewWrapperScroll, previewWrapperScroll => {
  var _previewWrapperScroll;
  return (_previewWrapperScroll = previewWrapperScroll === null || previewWrapperScroll === void 0 ? void 0 : previewWrapperScroll.scrollLeft) !== null && _previewWrapperScroll !== void 0 ? _previewWrapperScroll : 0;
});
export const getPreviewIframeNeedsRefresh = createInpageSelector('iframeNeedsRefresh');
export const getComputedStylesForAllSelectors = createInpageSelector('computedStylesBySelector');
const getComputedHidden = computedStyles => {
  if (!computedStyles) {
    return null;
  }
  if (computedStyles['display'] === 'none') {
    return true;
  } else {
    return false;
  }
};
const getComputedStylesForSelector = basicSelectorWithStats((state, {
  selector
}) => {
  if (!selector) {
    throw new Error('Must pass in a selector prop to getComputedStylesForSelector');
  }
  const stylesBySelector = getComputedStylesForAllSelectors(state);
  return stylesBySelector === null || stylesBySelector === void 0 ? void 0 : stylesBySelector[selector];
});
const getComputedStylesForNode = basicSelectorWithStats((state, {
  node
}) => {
  if (!node) {
    throw new Error('Must pass in a node prop to getObservedComputedStylesForNode');
  }
  const stylesBySelector = getComputedStylesForAllSelectors(state);
  const selectorForNode = buildTreeNodeDomSelector(node);
  return stylesBySelector === null || stylesBySelector === void 0 ? void 0 : stylesBySelector[selectorForNode];
});
const getAllComputedStylesForGridNode = basicSelectorWithStats((state, {
  node
}) => {
  if (!node) {
    throw new Error('Must pass in a node prop to getAllComputedStylesForGridNode');
  }
  const stylesBySelector = getComputedStylesForAllSelectors(state);
  const selectorForNode = getGridNodeElementSelector(node);
  return stylesBySelector === null || stylesBySelector === void 0 ? void 0 : stylesBySelector[selectorForNode];
});
export const makeGetComputedHiddenForGridNode = () => createSelector(getAllComputedStylesForGridNode, getComputedHidden);
export const makeGetComputedMaxWidthForGridNodeForSelector = () => createSelector(getComputedStylesForSelector, computedStyles => {
  if (computedStyles) {
    const maxWidth = computedStyles['max-width'];
    if (maxWidth) {
      return stringSizeToChirpSize(maxWidth);
    }
  }
  return null;
});
export const makeGetComputedStylesForGridNode = () => createSelector(makeGetComputedHiddenForGridNode(), computedHidden => ({
  computedHidden
}));
export const makeGetComputedBackgroundColorForNode = () => createSelector(getComputedStylesForNode, computedStyles => {
  if (!computedStyles) {
    return null;
  }
  const backgroundColor = computedStyles['background-color'];
  if (backgroundColor) {
    const rgbaObject = convertRgbaStringToRgbaObject(backgroundColor);
    if (rgbaObject) {
      return convertRgbaToHexAndAlphaInt(rgbaObject);
    }
  }
  return null;
});
const MARGIN_AND_PADDING_DIRECTIONS = ['top', 'bottom', 'left', 'right'];
export const makeGetComputedMarginForNode = () => createSelector(getComputedStylesForNode, computedStyles => {
  if (!computedStyles) {
    return null;
  }
  const marginObject = {};
  MARGIN_AND_PADDING_DIRECTIONS.forEach(marginDirection => {
    marginObject[marginDirection] = parseFloat(computedStyles[`margin-${marginDirection}`]);
  });
  return marginObject;
});
export const makeGetComputedPaddingForNode = () => createSelector(getComputedStylesForNode, computedStyles => {
  if (!computedStyles) {
    return null;
  }
  const paddingObject = {};
  MARGIN_AND_PADDING_DIRECTIONS.forEach(paddingDirection => {
    paddingObject[paddingDirection] = parseFloat(computedStyles[`padding-${paddingDirection}`]);
  });
  return paddingObject;
});
export const makeGetComputedHiddenForNode = () => createSelector(getComputedStylesForNode, getComputedHidden);
export const makeGetComputedMaxWidthForSelector = () => createSelector(getComputedStylesForSelector, computedStyles => {
  if (computedStyles) {
    const maxWidth = computedStyles['max-width'];
    if (maxWidth === 'none') {
      return maxWidth;
    } else if (maxWidth) {
      return parseFloat(computedStyles[`max-width`]);
    }
  }
  return null;
});
const makeProcessInpageNormalizedModule = (moduleId, builtInTypesByModuleId, customModuleIds, isUneditableModule) => {
  return createSelector(makeGetAnyModuleById(moduleId), module => {
    // Don't fail on things like fake modules, that will return as false-y values from makeGetAnyModuleById
    return module ? processModuleForIPEUI({
      builtInTypesByModuleId,
      customModuleIds: [],
      makeOverrideable: !isUneditableModule,
      module: module.toJS()
    }) : undefined;
  });
};

// Note, some excluded modules (e.g. fake ones) will be returned as undefined from
// makeProcessInpageNormalizedModule, that's why there is a `!!module` check
const shouldIncludeModuleInInpage = module =>
// @ts-expect-error can't call includes on a const list
!!module && module.name && !INPAGE_MODULE_BLOCKLIST.includes(module.type);
const cachedGetInpageNormalizedModules = () => {
  let cachedModuleSelectors = {};
  const selectorFunc = createSelector(getBuiltInTypesByModuleId, getCustomModuleIds, getModuleLists, getModuleSchemas, getModules, getUneditableModules, getAuth, getIsUngatedForImmerModuleReducer, (builtInTypesByModuleId, customModuleIds, moduleLists, moduleSchemas, regularModules, uneditableModules, auth, isUngatedForImmerModuleReducer) => {
    const gateCheckedBuildFakeModulesSlice = isUngatedForImmerModuleReducer ? buildFakeModuleSliceImmer : buildFakeModuleSlice;
    const fakedState = Object.assign({}, gateCheckedBuildFakeModulesSlice(moduleLists, auth), buildFakeModuleSchemasSlice(moduleSchemas));
    const modulesByCategory = {
      regularModules: Object.values(regularModules),
      uneditableModules: Object.values(uneditableModules)
    };
    const nestedModuleArrays = Object.keys(modulesByCategory).map(filteredKey => {
      const modules = modulesByCategory[filteredKey];
      const isUneditableModule = filteredKey === 'uneditableModules';
      return modules.map(module => {
        // @ts-expect-error will be cleaned up after module reducer migration
        const moduleName = module.get('name');

        // Early bail on missing module name (it would get filtered via shouldIncludeModuleInInpage
        // eventually anyway)
        if (!moduleName) {
          return undefined;
        }
        if (!cachedModuleSelectors[moduleName]) {
          cachedModuleSelectors[moduleName] = makeProcessInpageNormalizedModule(moduleName, builtInTypesByModuleId, customModuleIds, isUneditableModule);
        }
        const processedModule = cachedModuleSelectors[moduleName](fakedState);
        return shouldIncludeModuleInInpage(processedModule) ? processedModule : undefined;
      });
    });

    // Flatten (since `flatMap` isn't everywhere yet) and filter out undefined items
    return nestedModuleArrays.reduce((result, modules) =>
    // eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy
    result.concat(modules.filter(m => m !== undefined)), []);
  });

  // Reset method for testing
  // @ts-expect-error not technically part of selector type
  selectorFunc._testOnlyResetCachedModuleSelectors = () => {
    cachedModuleSelectors = {};
  };
  return selectorFunc;
};
export const getInpageNormalizedModules = cachedGetInpageNormalizedModules();
export const getInpageModulesInsideFlexColumns = createSelector(getInpageNormalizedModules, modules => {
  // @ts-expect-error we use modules as discriminant unions here
  return modules.filter(module => module.isInContainer);
});
export const getInpageModulesOutsideContainers = createSelector(getInpageNormalizedModules, getIsBlogPost, (modules, isBlogPost) => {
  const filteredModules = modules.filter(module =>
  // @ts-expect-error we use modules as discriminant unions here
  !module.isInContainer &&
  // @ts-expect-error we use modules as discriminant unions here
  !module.layout_section_id &&
  // @ts-expect-error we use modules as discriminant unions here
  !module.grid_layout_id);
  if (!isBlogPost) {
    return filteredModules;
  }
  return filteredModules.sort((moduleA, moduleB) => {
    if (moduleA.name === 'post_body') {
      return 1;
    } else if (moduleB.name === 'post_body') {
      return -1;
    } else {
      return 0;
    }
  });
});
export const getInpageModulesInsideLayoutSections = createSelector(getInpageNormalizedModules, modules => {
  // @ts-expect-error we use modules as discriminant unions here
  return modules.filter(module => module.layout_section_id);
});
export const getInpageModulesInsideGridLayouts = createSelector(getInpageNormalizedModules, modules => {
  // @ts-expect-error we use modules as discriminant unions here
  return modules.filter(module => module.grid_layout_id);
});
export const getUseScrollIfModuleOutOfBoundsAtAll = createSelector([getInpageData], inpageData => inpageData.useScrollIfModuleOutOfBoundsAtAll);
export const getNopeZoneSelector = createSelector([getInpageData], inpageData => inpageData.nopeZoneSelector);